export const API_ROUTES = {
  LOGIN: '/v1/auth/login',
  LOGOUT: '/v1/auth/logout',
  REGISTER: '/v1/auth/register',
  LIST_STATS: '/v1/stats/list',
  STAT_DATA: (id, ts) => `/v1/stats/data/${id}?starting=${ts}`,
  EARLY_ADOPTERS: '/v1/early-adopters-program',
  PROFILE: '/v1/auth/profile',
};
